<template>
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <button type="button" @click="router.back()" class="btn btn-outline-secondary me-3 rounded-0"><font-awesome-icon icon="chevron-left" /> Zurück</button>

      <h1 class="mb-0">{{ user?.firstName }} {{ user?.lastName }}</h1>
    </div>

    <div v-if="user != undefined" class="d-flex align-items-center justify-content-end gap-2">
      <EditUserPasswordModal :user="user" :index="0" :realm="realm" />
      <EditUserModal :user="user" :index="0" :buttonStyle="1" :realm="realm" @delete-benutzer="deleteBenutzer" @saved-benutzer="getBenutzerById" />
    </div>
  </div>

  <pre>{{ user }}</pre>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onBeforeUnmount, onMounted, PropType, watch } from 'vue';
  import { useRouter } from 'vue-router';

  import EditUserModal from '@/components/Benutzer/EditUserModal.vue';
  import EditUserPasswordModal from '@/components/Benutzer/EditUserPasswordModal.vue';

  import { useBenutzerStore } from '@/stores/benutzerStore';
  import { User, UserRealmIdRequest } from '@/models/BenutzerModels';
  //#endregion

  const { realm, id } = defineProps({
    realm: {
      type: String as PropType<string>,
      default: 'admin',
    },

    id: {
      type: String as PropType<string>,
      required: true,
    },
  });

  const router = useRouter();

  const benutzerStore = useBenutzerStore();
  const user = computed(() => benutzerStore.user as User);

  async function deleteBenutzer() {
    await benutzerStore.deleteRealmUser(new UserRealmIdRequest(realm, id)).then(() => {
      router.back();
    });
  }

  async function getBenutzerById() {
    benutzerStore.resetUser();
    const request = new UserRealmIdRequest(realm, id);
    await benutzerStore.getRealmUserById(request);
  }

  watch(
    () => id,
    async () => {
      if (id) {
        await getBenutzerById();
      }
    }
  );

  onMounted(async () => {
    await getBenutzerById();
  });

  onBeforeUnmount(() => {
    benutzerStore.resetUser();
  });
</script>
